<template>
    <div
        class="tw-flex tw-items-center tw-gap-4 tw-my-10"
    >
        <div
            class="tw-w-24 tw-h-24 tw-bg-red-300 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-4xl tw-font-medium tw-font-inter tw-text-gray-500"
        >
            {{ number }}
        </div>
        <div
            class="tw-content-center tw-w-2/3 tw-text-lg"
        >
            <slot />
        </div>
    </div>
</template>

<script>

    export default {
        name: "NextStepsSnippet",
        components: {
        },
        props: {
            number: {
                type: Number,
                required: true,
            },
        },
    }
</script>

<style scoped>
</style>